<template>
  <van-overlay className="loading" :show="visible">
    <van-loading class="wrapper" color="#0094ff" vertical>加载中...</van-loading>
  </van-overlay>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Loading',
  props: {
    visible: Boolean,
  },
  setup() {},
});
</script>

<style lang="less">
.loading {
  height: 100vh;
  width: 100vw;
  z-index: 9999;
  & > .wrapper {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>